// extracted by mini-css-extract-plugin
export default {"nextVersion":"next-version__nextVersion","itemContainer":"next-version__itemContainer"};